import aliciaProfile from "../assets/PROFILE_PIC.jpeg";
import aliciaHomeTherapy from "../assets/alicia-home-therapy-v2.jpg";

export const CONTACT = {
  email: "info@soraspeechco.com",
  phone: "0421 419 343",
  practitioner: "Alicia Lim",
  qualifications: "Bachelor of Applied Science, Master of Speech Pathology",
  tagline: "Proudly providing mobile speech pathology across most of metropolitan Melbourne.",
  hours: [
    { day: "Wednesday – Friday", time: "10:00am – 6:00pm" },
    { day: "Saturday", time: "By appointment" },
  ],
  regions: ["Box Hill", "Doncaster", "Camberwell", "Ringwood", "Glen Waverley", "Dandenong", "Frankston", "Preston", "Coburg", "Bundoora", "Footscray", "Sunshine", "Essendon", "Werribee"],
};

export const LOGO = "https://customer-assets.emergentagent.com/job_voice-confident-au/artifacts/xl5opmtk_logo.png";

export const IMAGES = {
  hero: aliciaHomeTherapy,
  portrait: aliciaProfile,
  interior: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sunlit: "https://images.unsplash.com/photo-1583329550487-0fa300a4cd1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  reading: "https://images.unsplash.com/photo-1758598737990-83994c6a19d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  reviews: "https://static.prod-images.emergentagent.com/jobs/8b57c759-cce9-47b0-a21d-7b49bd9f89e0/images/3673f6494cb1241e3b25c05a2ad55fd67b3953916f0e1e747c9b0cdc05814be1.png",
  blocks: "https://images.unsplash.com/photo-1596962390809-2c147eeb9aff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  childPlay: "https://images.pexels.com/photos/3662628/pexels-photo-3662628.jpeg?auto=compress&cs=tinysrgb&w=1200",
  babyBlocks: "https://images.unsplash.com/photo-1763478938361-ee1612a368da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plant: "https://images.unsplash.com/photo-1493552152660-f915ab47ae9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  bookReading: "https://images.unsplash.com/photo-1545239351-e1433db9a918?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICES = [
  { icon: "MessageCircle", title: "Speech Sounds", desc: "Supporting clear, confident pronunciation so children can be understood and heard.",
    who: "Children with unclear speech, sound errors, or difficulty being understood.",
    goals: ["Produce sounds accurately", "Improve speech clarity", "Build confidence when speaking"],
    activities: ["Playful sound games", "Mirror and tactile cues", "Storybook practice"],
    assessment: "Single-word and connected-speech sampling, oral-motor screening.",
    treatment: "Evidence-based articulation and phonological approaches, tailored home practice.",
    outcomes: "Clearer, more intelligible speech and greater confidence in everyday conversation." },
  { icon: "Sparkles", title: "Language", desc: "Growing understanding and expression — words, sentences, and meaningful connection.",
    who: "Children with delayed talking, word-finding, or understanding difficulties.",
    goals: ["Expand vocabulary", "Build sentence structure", "Follow and give instructions"],
    activities: ["Play-based interaction", "Shared book reading", "Everyday routines"],
    assessment: "Standardised language assessment and observation in natural play.",
    treatment: "Naturalistic, child-led language facilitation and parent coaching.",
    outcomes: "Richer vocabulary, clearer sentences, and stronger comprehension." },
  { icon: "Users", title: "Social Communication", desc: "Nurturing connection, play, and the back-and-forth of genuine interaction.",
    who: "Children building conversation, play, and relationship skills.",
    goals: ["Initiate and sustain interaction", "Read social cues", "Play alongside peers"],
    activities: ["Turn-taking games", "Role-play", "Peer and sibling play"],
    assessment: "Play-based observation and caregiver interview.",
    treatment: "Neurodiversity-affirming, strengths-based social communication support.",
    outcomes: "More comfortable, connected interactions on the child's terms." },
  { icon: "BookOpen", title: "Literacy", desc: "Strong foundations for reading, spelling, and writing that grow with your child.",
    who: "Children finding reading, spelling, or writing challenging.",
    goals: ["Phonological awareness", "Decoding and spelling", "Reading comprehension"],
    activities: ["Sound-letter play", "Structured literacy tasks", "Shared reading"],
    assessment: "Phonological awareness and literacy screening.",
    treatment: "Structured, systematic literacy intervention aligned with school — trained in Sounds-Write and READ 3 systematic intervention programs.",
    outcomes: "Confident, capable readers and writers." },
  { icon: "Heart", title: "Developmental Disabilities", desc: "Individualised, compassionate support that honours every child's unique path.",
    who: "Children with developmental disabilities and complex communication needs.",
    goals: ["Functional communication", "Participation", "Independence and choice"],
    activities: ["Multimodal communication", "AAC exploration", "Everyday routines"],
    assessment: "Holistic, family-centred assessment across environments.",
    treatment: "Individualised goals, AAC where helpful, and close family collaboration.",
    outcomes: "Meaningful communication that supports connection and participation." },
];

export const WHY_US = [
  { icon: "HandHeart", text: "Warm and welcoming" },
  { icon: "FlaskConical", text: "Evidence-based" },
  { icon: "Baby", text: "Child-led therapy" },
  { icon: "Home", text: "Family-centred" },
  { icon: "Target", text: "Individualised goals" },
  { icon: "ShieldCheck", text: "NDIS experience" },
  { icon: "Car", text: "Mobile services" },
  { icon: "Video", text: "Telehealth" },
];

export const CONDITIONS = [
  { title: "Autism", icon: "Puzzle" },
  { title: "ADHD", icon: "Waves" },
  { title: "Down syndrome", icon: "Flower2" },
  { title: "Intellectual disability", icon: "Lightbulb" },
  { title: "Global developmental delay", icon: "Sprout" },
  { title: "Language delay", icon: "Clock" },
  { title: "Language disorder", icon: "MessagesSquare" },
  { title: "Literacy difficulties", icon: "PenLine" },
  { title: "Articulation difficulties", icon: "VolumeX" },
  { title: "AAC", icon: "Tablet" },
];

export const SETTINGS = [
  { title: "Home", icon: "Home", desc: "Therapy woven into your child's most comfortable, familiar space." },
  { title: "Childcare", icon: "Blocks", desc: "Support embedded within your child's daily early-learning routine." },
  { title: "Kindergarten", icon: "Backpack", desc: "Collaborating with educators to support communication and readiness." },
  { title: "School", icon: "GraduationCap", desc: "Working alongside teachers to support learning and literacy." },
  { title: "Community", icon: "Trees", desc: "Practising skills in the real, everyday places your family goes." },
  { title: "Telehealth", icon: "Video", desc: "Warm, effective online sessions where appropriate and convenient." },
];

export const TESTIMONIALS = [
  { quote: "Alicia has a gift for meeting our son exactly where he is. He now comes home with new words and, more importantly, so much more confidence.", author: "Rebecca M.", role: "Parent, Bentleigh" },
  { quote: "Having therapy at home changed everything. There's no rushing between appointments and our daughter is completely at ease.", author: "James & Priya T.", role: "Parents, Doncaster" },
  { quote: "Genuinely warm, deeply knowledgeable, and never clinical. Sora Speech Co. feels like a true partner in our family's journey.", author: "Hannah L.", role: "Parent, Craigieburn" },
];

export const VALUES = [
  { title: "Compassion", icon: "Heart", desc: "We meet every child and family with warmth, patience, and genuine care." },
  { title: "Evidence", icon: "FlaskConical", desc: "Our practice is grounded in current, high-quality speech pathology research." },
  { title: "Connection", icon: "Users", desc: "Meaningful relationships are the foundation of meaningful communication." },
  { title: "Growth", icon: "Sprout", desc: "We celebrate progress at every pace, honouring each child's unique path." },
];

export const TIMELINE = [
  { year: "2012", text: "Completed Bachelor of Applied Science, beginning a lifelong passion for child development." },
  { year: "2014", text: "Graduated with a Master of Speech Pathology and joined a paediatric team." },
  { year: "2017", text: "Specialised in early intervention and neurodiversity-affirming practice." },
  { year: "2020", text: "Became an experienced NDIS provider, supporting families across Melbourne." },
  { year: "2024", text: "Founded Sora Speech Co. to bring premium mobile therapy into children's everyday lives." },
];

export const NDIS_INFO = [
  { title: "Self Managed", icon: "Wallet", desc: "You manage your NDIS funds directly. We provide clear invoices for you to claim, giving you full flexibility and choice over your child's supports." },
  { title: "Plan Managed", icon: "FileCheck", desc: "Your plan manager handles the paperwork and payments. We simply send invoices to them — a seamless, stress-free option for busy families." },
];

export const NDIS_SUPPORTS = [
  { title: "Services available", icon: "ListChecks", desc: "Assessment, individual therapy, AAC support, parent coaching, and school collaboration." },
  { title: "Travel", icon: "Car", desc: "We come to you across most of metropolitan Melbourne — home, childcare, kinder, or school." },
  { title: "Reports", icon: "FileText", desc: "Clear, plan-ready reports to support reviews and funding requests." },
  { title: "Assessments", icon: "ClipboardCheck", desc: "Comprehensive, standardised assessments to guide goals and evidence needs." },
  { title: "Progress reviews", icon: "TrendingUp", desc: "Regular, collaborative reviews so goals stay meaningful and current." },
];

export const RESOURCES = [
  { title: "Speech Sound Milestones", cat: "Milestones", type: "PDF Guide", desc: "An age-by-age guide to the sounds children typically develop." },
  { title: "Early Literacy at Home", cat: "Literacy", type: "PDF Guide", desc: "Simple, everyday ways to build reading foundations through play." },
  { title: "Parent Tips: Everyday Talk", cat: "Parent Tips", type: "Article", desc: "Small moments, big impact — weaving language into daily routines." },
  { title: "School Readiness Checklist", cat: "School Readiness", type: "PDF Guide", desc: "Communication skills that help children thrive as they start school." },
  { title: "Understanding AAC", cat: "AAC", type: "Article", desc: "An introduction to augmentative and alternative communication." },
  { title: "Language Milestones 2–5 Years", cat: "Milestones", type: "PDF Guide", desc: "What to expect and celebrate in your child's early language." },
];

export const BLOG = [
  { title: "Why child-led play is powerful therapy", cat: "Approach", read: "4 min read" },
  { title: "Supporting late talkers with confidence", cat: "Early Intervention", read: "6 min read" },
  { title: "Neurodiversity-affirming practice, explained", cat: "Neurodiversity", read: "5 min read" },
];

export const FAQS = [
  { q: "Do I need a referral to see a speech pathologist?", a: "No referral is needed to book as a private paying client or through self/plan-managed NDIS. If you are accessing certain funding pathways (such as a Medicare care plan), your GP can provide a referral — we're happy to guide you." },
  { q: "Do you accept NDIS?", a: "Yes. We are an experienced NDIS provider and support Self Managed and Plan Managed participants. We provide clear invoices and plan-ready reports to make the process simple." },
  { q: "Where do you travel?", a: "We provide mobile speech pathology across most of metropolitan Melbourne. We come to your home, childcare, kindergarten, or school. Not sure if you're within range? Just ask." },
  { q: "Do you offer telehealth?", a: "Yes. Where appropriate, we offer warm and effective telehealth sessions — a wonderful option for families in busy schedules or further afield." },
  { q: "What does the assessment process look like?", a: "We begin by getting to know your child and your family's goals. Assessment blends standardised tools with natural, play-based observation, followed by a clear plan and, where needed, a written report." },
  { q: "What are your fees?", a: "We welcome both NDIS (Self and Plan Managed) and private paying clients. Fees align with the current NDIS price guide for therapy supports. A detailed fee schedule for assessments, sessions, travel, and reports is available on request — please contact us and we'll send it through." },
  { q: "Will I receive reports?", a: "Yes. We provide clear, family-friendly reports for assessments and progress reviews, written to support NDIS plans, school collaboration, and funding requests." },
];
